import React from 'react';
import Link from 'gatsby-link';
import imgCF from './jake.jpg';
import BackNav from '../components/BackNav';
import FooterRainbow from '../components/FooterRainbow';

// Crossfader Images
import imgCF1 from '../images/crossfader/crossfader-doors.gif';
import imgCF2 from '../images/crossfader/playlist-wires.png';
import imgCF3 from '../images/crossfader/playlist.jpg';
import imgCF4 from '../images/crossfader/playlist-2.jpg';
import imgCF5 from '../images/crossfader/process-1.jpg';
import imgCF6 from '../images/crossfader/process-2.jpg';
import imgCF7 from '../images/crossfader/icon-process.png';
import imgCF8 from '../images/crossfader/crossfader-m5.jpg';
import imgCF9 from '../images/crossfader/crossfader-m3.jpg';
import imgCF10 from '../images/crossfader/story-radio-v2.png';
import imgCF11 from '../images/crossfader/old-web.png';
import imgCF12 from '../images/crossfader/skypegrid.jpg';
import imgCF13 from '../images/crossfader/onboarding1.gif';
import imgCF14 from '../images/crossfader/onboarding2.gif';
import imgCF15 from '../images/crossfader/onboarding3.gif';
import imgCF16 from '../images/crossfader/onboarding4.gif';
import imgCF17 from '../images/crossfader/mixes-1.jpg';
import imgCF18 from '../images/crossfader/mixes-2.jpg';
import imgCF19 from '../images/crossfader/live-1.png';
import imgCF20 from '../images/crossfader/live-2.jpg';
import imgCF21 from '../images/crossfader/crossfader-display-1.jpg';
import imgCF22 from '../images/crossfader/iterating.png';
import imgCF23 from '../images/crossfader/55-1.png';
import imgCF24 from '../images/crossfader/55-2.png';
import imgCF25 from '../images/crossfader/55-3.png';
import imgCF26 from '../images/crossfader/jake.jpg';
import imgCFunce from '../images/crossfader/unce.gif';

const Crossfader = () =>
  <div>
    <div className="main work-page relative">
      <BackNav />
      <div className="row">
        <h1 className='huge-text col-sm-12'>Crossfader</h1>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <p className="lead">Crossfader is the world’s simplest DJ app. Tilt the phone to mix seamlessly between tracks, and broadcast your mix live across the globe — plus weekly curated playlists of the hottest music.<br /><br />
          At Crossfader we built an amazing product that a core group of users were fanatic about. The feedback from our obsessed users was the fuel we used to keep pushing the experience to be as great as it could be. Ultimately, we were unable to scale our hyper-engaged user base, or implement a business model that allowed us to become profitable. <br /><br />
          As the sole product designer, I worked closely with the entire team to define the functionality and flow of new features, create and iterate on interaction and visual designs, then oversee (for iOS) and execute (on the web - writing JS &amp; CSS / our last website version was built in React JS) the implementation of final designs. After shipping updates, I would synthesize user feedback and look at usage data to guide the next release. Also created the logo, branding, and essentially everything Crossfader-related. Crossfader is <a href="https://itunes.apple.com/us/app/crossfader/id628517073?mt=8">available in the app store.</a></p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 hidden-xs">
          <p className="lead centertext">Video overview:</p>
          <iframe width="640" height="360" src="http://www.youtube.com/embed/Eh_Np6qTH5g?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <h2>Playlist &amp; Prototyping</h2>
          <p className="lead">My first challenge at Crossfader was to redesign the ‘playlist’ experience. After brainstorming many possible interactions, we prototyped the ‘barn doors’ experience and were captivated by how engaging it was. The direct manipulation was fun and simple, and made mixing through a playlist very fun. Prototyping interactions was essential to our process as we tried to create the most intuitive and fluid mixing experience possible.</p>
        </div>
        <div className="col-sm-12">
          <a href="http://jsfiddle.net/williamnewton/sSkLx/">
            <div className='onboarding-gifs'>
              <img className="img-responsive" src={imgCF1} />
            </div>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <img className="img-responsive" src={imgCF2} />
        </div>
        <div className="col-sm-6">
          <img className="img-responsive" src={imgCF3} />
        </div>
        <div className="col-sm-6">
          <img className="img-responsive" src={imgCF4} />
        </div>

      </div>

      <div className="row">
        <div className="col-sm-12">
          <h2>The Cross — 2013/2014</h2>
          <div className="col-sm-8">
            <p className="lead">Towards the end of 2013, we were deliberating on how to best share content from the app. We used to export recordings to Soundcloud. But after the bot takedowns started, this was no longer a feasible solution. We had to do something totally different.<br /><br />The way I thought about the problem was this : what is magical about Crossfader? <i>Being able to play two songs at once, seamlessly, and mixing them together.</i> So what’s the smallest sharable unit? <i>The two songs, playing at any given moment, together.</i><br /><br />The Cross was born. Crosses were easy to make, easy to share, and playable on the web. You could open them up and start mixing them yourself. It was like a musical snapshot. Over the next year, we explored many ways to ‘consume’ crosses, from feeds to an auto-magical radio that stitched crosses together to create a crowdsourced mixtape.</p>
          </div>
          <div className="col-sm-4 pull-right">
            <img className="img-responsive" src={imgCF5} />
            <img className="img-responsive" src={imgCF6} />
            <img className="img-responsive" src={imgCF7} />
            <img className="img-responsive" src={imgCF8} />
          </div>
          <div className="col-sm-8">
            <img className="img-responsive" src={imgCF9} />
          </div>
        </div>
        <div className="col-sm-4">
          <img className="img-responsive" src={imgCF10} />
        </div>
        <div className="col-sm-8">
          <img className="img-responsive shadow" src={imgCF11} />
        </div>
      </div>

      <div className="row">
        <div className="col-12-sm">
          <h2>Research</h2>
          <p className="lead">I've interviewed over 50 of our top users, and learned tons qualitatively and quantitatively about how our top users used the app - about what they loved about it - what they hated - what they wish they could do - how they used it - and how I could improve those experiences for them.</p>
          <img className="img-responsive" src={imgCF12} />
        </div>
      </div>

      <div className="row">
        <div className="col-12-sm">
          <h2>Onboarding — 2015</h2>
          <p className="lead">We found that the largest barrier to user activation was that many people never had the 'Ah-Hah' moment while discoverign Crossfader. The 'DJing' part of the app was difficult to understand how to use without being <i>shown</i>. In lieu of pop-over videos, we integrated these animations as overlays to teach new users the core Crossfader mechanics. </p>
        </div>
      </div>
      <div className="row margin-bottom-50">
        <div className="onboarding-gifs">
          <div className="flex-horizontal">
            <img className="img-responsive" src={imgCF13} />
            <img className="img-responsive padding-top-50" src={imgCF14} />
          </div>
          <div className="flex-horizontal">
            <img className="img-responsive" src={imgCF15} />
            <img className="img-responsive" src={imgCF16} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12-sm">
          <h2><br />Recorded Mixes — 2014/2015</h2>
          <p className="lead">After a year, crosses seemed to feel flat. They didn’t capture the expressiveness and the joy that came from mixing with Crossfader - fading from song to song, creating a unique performance. Sentiment from the hours I spent talking to users hinted that they wanted something more, to share their mixing as widely as possible, and to save and listen back to their sessions. We spent the rest of the year building out the app to support recorded mixes, we axed the ‘cross’, and pushed the product towards where it would ultimately support live streaming Crossfading. We were moving away from what felt like ‘spammy’ snapshots to more carefully crafted mixes, that the creators were very proud of. </p>
          <div className="col-sm-6">
            <img className="img-responsive" src={imgCF17} />
          </div>
          <div className="col-sm-6">
            <img className="img-responsive" src={imgCF18} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12-sm">
          <h2>Live — 2015/2016</h2>
          <p className="lead col-sm-7">Asynchronous mixing, listening, and liking was engaging — but we knew that our users yearned for that *real* conncetion with eachother. On August 20, 2015, we released version 5, which supported live Crossfading. The concept of ‘recording’ was replaced with ‘going live’. Over the past 6 months we’ve seen steady growth in our most engaged cohort of users, and community emerge with things like regular digital festivals and radio shows. </p>
          <img className="col-sm-5" src={imgCFunce} />
          <div className="col-sm-6">
            <img className="img-responsive" src={imgCF19} />
          </div>
          <div className="col-sm-6">
            <img className="img-responsive" src={imgCF20} />
          </div>
          <div className="col-sm-12">
            <img className="img-responsive" src={imgCF21} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12-sm">
        <img className="col-sm-4 pull-right" src={imgCF21} />
          <h2>UX Overhaul — 2016</h2>
          <p className="lead col-sm-8">The last major release of Crossfader (5.5) focuses on many UX improvements (performance, in-app notifications, tagging djs, improved profile customization, default mix photos) and a new visual consistency that gets ‘style’ out of the way. Crossfader was always a content-first platform, and this latest release gives our users more control than ever over how they express themselves musically and visually within the app.</p>
          <img className="col-sm-12" src={imgCF22} />
          <img className="col-sm-4" src={imgCF23} />
          <img className="col-sm-4" src={imgCF24} />
          <img className="col-sm-4" src={imgCF25} />
        </div>
      </div>


       <div className="row">
          <div className="col-sm-12">
            <img className="img-responsive" src={imgCF26} />
          </div>
        </div>
      </div>

    <FooterRainbow />

  </div>

export default Crossfader



// WEBPACK FOOTER //
// ./src/pages/crossfader.js